import React from 'react';
import { connect } from 'react-redux';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import moment from "moment";

import PopupCustomized from '../../../../../components/PopupCustomized';
import DateRangePicker from '../../../../../components/v3/DateRangePicker/DateRangePicker';
import FilterArrow from '../../../../../icons/v3/FilterArrow';
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import HelpOutline from '@material-ui/icons/HelpOutline';
import BarChartContainer from './BarChartContainer';
import BarChartTeamCompareContainer from './BarChartTeamCompareContainer';

import SelectTable from '../../../../../components/v3/CalibrationScreenV3/SelectTable';
import { dateFormat, filterType } from '../../../../../constants';

import {
    updateProps,
    loadProgressOverTimeStats,
} from '../../CalibrationV3ScreenActions';
import { isDefined, getDate, arrayIsNotEmpty } from '../../../../../utils';

class TeamsCompareAndOverTimeGraphs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showSelectTeamPopup: false,
            selectedTeams: undefined,
            fromDate: undefined,
            toDate: moment().format(dateFormat),
            selectedTimePeriodicityId: 1,
            mouseClickX: 100,
            mouseClickY: 100,
        };

        this.showSelectTeamPopup = this.showSelectTeamPopup.bind(this);
        this.hideSelectTeamPopup = this.hideSelectTeamPopup.bind(this);

        this.getSelectTeamPopup = this.getSelectTeamPopup.bind(this);
        this.getSelectedTeamsNode = this.getSelectedTeamsNode.bind(this);
        this.removeTeam = this.removeTeam.bind(this);

        this.getDateFiltersNode = this.getDateFiltersNode.bind(this);

        this.setNewTimeRangeForProgressOverTime = this.setNewTimeRangeForProgressOverTime.bind(this);
        this.onSelectNewTimePeriodicity = this.onSelectNewTimePeriodicity.bind(this);
        this.showTeamComparisonHelpPopup = this.showTeamComparisonHelpPopup.bind(this);
        this.closeTeamComparisonHelpPopup = this.closeTeamComparisonHelpPopup.bind(this);
        this.showProgressOverTimeHelpPopup = this.showProgressOverTimeHelpPopup.bind(this);
        this.closeProgressOverTimeHelpPopup = this.closeProgressOverTimeHelpPopup.bind(this);
    }

    showTeamComparisonHelpPopup(e) {
        this.setState({ showTeamComparisonHelpPopup: true, mouseClickX: e.clientX, mouseClickY: e.clientY });
    }

    closeTeamComparisonHelpPopup() {
        this.setState({ showTeamComparisonHelpPopup: false });
    }

    showProgressOverTimeHelpPopup(e) {
        this.setState({ showProgressOverTimeHelpPopup: true, mouseClickX: e.clientX, mouseClickY: e.clientY });
    }

    closeProgressOverTimeHelpPopup() {
        this.setState({ showProgressOverTimeHelpPopup: false });
    }

    showSelectTeamPopup() {
        this.setState({ showSelectTeamPopup: true });
    }

    hideSelectTeamPopup(selectedTeams) {
        this.setState({ showSelectTeamPopup: false });

        if (((!selectedTeams || selectedTeams.length == 0) &&
            (!this.state.selectedTeams || this.state.selectedTeams.length == 0))) {
            return;
        }
        if (selectedTeams && this.state.selectedTeams) {
            if (JSON.stringify(selectedTeams) == JSON.stringify(this.state.selectedTeams)) {
                return;
            }
        }

        if (selectedTeams && selectedTeams.length == 0)
            this.setState({ selectedTeams: undefined });
        else {
            this.setState({ selectedTeams });
        }
    }

    getSelectedTeamsNode() {
        if (!this.state.selectedTeams)
            return undefined;

        return this.getSelectedNode(filterType.team, this.state.selectedTeams, this.removeTeam);
    }

    removeTeam(id) {
        if (!this.state.selectedTeams || this.state.selectedTeams.length == 0)
            return;

        if (this.state.selectedTeams.length == 1) {
            this.setState({ selectedTeams: undefined });
        }
        else {
            const selectedTeamWithoutCurrent = this.state.selectedTeams.filter(t => t.id != id);
            this.setState({ selectedTeams: selectedTeamWithoutCurrent });
        }
    }

    setNewTimeRangeForProgressOverTime(fromDate, toDate) {
        this.setState({ fromDate: fromDate, toDate: toDate });
        this.props.onSelectNewTimeRange(fromDate, toDate, this.state.selectedTimePeriodicityId);
    }

    onSelectNewTimePeriodicity(selectedOption) {
        this.props.dispatch(updateProps({ progressOverTimeStats: undefined }));

        this.props.dispatch(loadProgressOverTimeStats(selectedOption.id,
            this.state.fromDate, this.state.toDate, undefined, undefined));

        this.setState({ selectedTimePeriodicity: selectedOption.id });
    }

    getSelectedNode(filterType, selectedValue, onClick) {
        let valueAndCloseIcon;
        if (Array.isArray(selectedValue)) {
            valueAndCloseIcon = selectedValue.map((s, index) => {
                if (index < 6) {
                    return (<div className="flex-container" key={s.id}>
                        <p className="H3_14 black-text" style={{ margin: '0 8px 0 8px' }} >{s.value}</p>
                        <HighlightOffIcon onClick={() => onClick(s.id)} style={{ margin: '0 0 0 4px', color: '#98DDE1' }} />
                    </div>);
                } else if (index === 6) {
                    return (<div className="flex-container" key={s.id}>
                        <p className="H3_14 grey-text" style={{ margin: '0 8px 0 8px' }} >more...</p>
                    </div>);
                }
            }
            );
        }
        else {
            valueAndCloseIcon = (<>
                <p className="H3_14 black-text" style={{ margin: '0 8px 0 8px' }} >{selectedValue.value}</p>
                <HighlightOffIcon onClick={() => onClick(selectedValue.id)} style={{ margin: '0 0 0 4px', color: '#98DDE1' }} />
            </>);
        }
        return (
            <div className="selected-node" key={selectedValue.id}>
                <p className="H3_14 orange-text" style={{ margin: '0 8px 0 8px' }} > {filterType}</p> <FilterArrow />
                {valueAndCloseIcon}
            </div>);
    }

    getSelectTeamPopup() {
        const
            {
                userTeamsStats,
            } = this.props;

        if (!userTeamsStats)
            return;

        return (<div className="modal displayBlock" >
            <div className="modal-content modal-content-selectTeam">
                <SelectTable
                    title="Select teams"
                    searchPlaceHolder="Search..."
                    selectMultiple={true}
                    options={userTeamsStats}
                    onClose={this.hideSelectTeamPopup} />
            </div>
        </div>);
    }

    getDateFiltersNode() {
        return (<div className="flex-container-start">
            <div style={{ margin: '0 0 0 20px' }}>
                <DateRangePicker
                    onClose={this.setNewTimeRangeForProgressOverTime} />
            </div>
        </div>);
    }

    render() {
        const
            {
                progressOverTimeStats,
                progressOverTimeStatsByTeam,
                teamsCalibrationStats,
                teamsJibedPercentageStats,
                calibratedOnSurveyQuestions,
                jibeSessionsPast30Days
            } = this.props;

        let teamPredictionAccuracyTitle = arrayIsNotEmpty(teamsCalibrationStats)
            ? `SHOWING YOUR TEAMS PREDICTION ACCURACY ON ${teamsCalibrationStats[0].windowStart.slice(0, 5)}`
            : undefined;

        let percentageOnTitle = arrayIsNotEmpty(teamsCalibrationStats)
            ? `SHOWING THE PERCENTAGE OF JIBED AGENTS IN EACH TEAM ON ${teamsCalibrationStats[0].windowStart.slice(0, 5)}`
            : undefined;

        const selectTeamPopup = this.state.showSelectTeamPopup ? this.getSelectTeamPopup() : undefined;
        const selectedTeamsNode = this.getSelectedTeamsNode();

        const filteredTeamsCalibrationStats = (this.state.selectedTeams && teamsCalibrationStats)
            ? teamsCalibrationStats.filter(t => (this.state.selectedTeams.some(st => st.id == t.aggregationId))
                || t.name === "All Teams")
            : teamsCalibrationStats;

        const teamCompHelp = "Compare how your team’s current Jibe prediction accuracy stack up against each other.";
        const progressOverTimeHelpText = "View what percentage of your agents are jibed.";

        const teamSelect = (
            <div className="v3-button graph-select-team" style={{ marginRight: '10px' }} onClick={this.showSelectTeamPopup}>
                <GroupAddIcon style={{ margin: '0 10px 0 0', color: '#98DDE1', transform: 'scale(-1, 1)' }} />
                Select Team
            </div>);

        const filtersAndSelectedValues = (
            <div style={{ display: 'inline-flex', alignItems: 'center', margin: '10px 0 18px 0' }}>
                <div style={{ display: 'inline-flex', flexWrap: 'wrap' }}>
                    {selectedTeamsNode}
                </div>

                {selectTeamPopup}
            </div>);

        if (arrayIsNotEmpty(this.state.selectedTeams)) {
            if (arrayIsNotEmpty(progressOverTimeStatsByTeam)) {
                const teamprogressOverTimeStats = progressOverTimeStatsByTeam.filter(t => t.aggregationId == this.state.selectedTeams[0].id);
                progressOverTimeStatsAll = teamprogressOverTimeStats.map(p => {
                    return {
                        effectiveDate: p.effectiveDate,

                        representativeSatisfaction: ((100 * p.representativeSatisfaction) / p.agentCount),
                        resolution: ((100 * p.resolution) / p.agentCount),
                        customerSatisfaction: ((100 * p.customerSatisfaction) / p.agentCount),
                        netPromoterScore: ((100 * p.netPromoterScore) / p.agentCount),

                        jibeSessionsPast30DaysCountRatio: p.jibeSessionsCount,
                    }
                });
            }

        }
        else {
            if (isDefined(progressOverTimeStats) && Array.isArray(progressOverTimeStats) && progressOverTimeStats.length > 0) {
                progressOverTimeStatsAll = progressOverTimeStats.map(p => {
                    return {
                        effectiveDate: p.effectiveDate,

                        representativeSatisfaction: ((100 * p.representativeSatisfaction) / p.agentCount),
                        resolution: ((100 * p.resolution) / p.agentCount),
                        customerSatisfaction: ((100 * p.customerSatisfaction) / p.agentCount),
                        netPromoterScore: ((100 * p.netPromoterScore) / p.agentCount),

                        jibeSessionsPast30DaysCountRatio: p.jibeSessionsCount,
                    }
                });
            }
        }

        const teamPredictionAccuracyNode = teamsCalibrationStats
            ? <BarChartContainer
                jibeSessionsPast30Days={jibeSessionsPast30Days}
                calibratedOnSurveyQuestions={calibratedOnSurveyQuestions}
                teamsCalibrationStats={teamsCalibrationStats}
                selectedTeams={this.state.selectedTeams} />
            //(<BarChart teams={teams} loading={false} changePeriod={this.changePeriod} />)
            : (<div className="flex justify-content-center" style={{ height: '398px', backgroundColor: 'rgb(252,252,255)' }}>
                <img src="../../../../../Assets/Images/V3Design/Zac.gif" width="350" />
            </div>);

        const teamPercentageOfJibedAgentsNode = teamsJibedPercentageStats
            ? <BarChartTeamCompareContainer
                jibeSessionsPast30Days={jibeSessionsPast30Days}
                calibratedOnSurveyQuestions={calibratedOnSurveyQuestions}
                teamsJibedPercentageStats={teamsJibedPercentageStats}
                selectedTeams={this.state.selectedTeams} />
            //(<BarChart teams={teams} loading={false} changePeriod={this.changePeriod} />)
            : (<div className="flex justify-content-center" style={{ height: '398px', backgroundColor: 'rgb(252,252,255)' }}>
                <img src="../../../../../Assets/Images/V3Design/Zac.gif" width="350" />
            </div>);

        return (
            <div className="system-dashboard-overall-border">
                <Tabs defaultIndex={1} >
                    <TabList>
                        <Tab>
                            <div className="flex-container-center description-title">
                                <div>Percentage of Jibed Agents</div>
                                <div className="flex-container-center" style={{ marginLeft: '5px' }}>
                                    <HelpOutline onClick={this.showProgressOverTimeHelpPopup} />
                                </div>
                            </div>
                            {
                                this.state.showProgressOverTimeHelpPopup &&
                                <PopupCustomized
                                    x={this.state.mouseClickX}
                                    y={this.state.mouseClickY}
                                    Message={progressOverTimeHelpText}
                                    close={this.closeProgressOverTimeHelpPopup} />
                            }
                        </Tab>
                        <Tab>
                            <div className="flex-container-center description-title">
                                <div>Jibe Prediction Accuracy</div>
                                <div className="flex-container-center" style={{ marginLeft: '5px' }}>
                                    <HelpOutline onClick={this.showTeamComparisonHelpPopup} />
                                </div>
                            </div>
                            {
                                this.state.showTeamComparisonHelpPopup &&
                                <PopupCustomized
                                    x={this.state.mouseClickX}
                                    y={this.state.mouseClickY}
                                    Message={teamCompHelp}
                                    close={this.closeTeamComparisonHelpPopup} />
                            }
                        </Tab>
                    </TabList>

                    <TabPanel >
                        <div className="flex-container" style={{
                            minHeight: '38px', margin: '0 0 15px 0', borderBottom: '1px solid #E6F7F8',
                        }}>
                            <div>
                                <div className="title-primary-400-24-28" style={{ fontSize: '14px' }}>
                                    {percentageOnTitle}
                                </div>
                            </div>
                        </div>
                        <div>
                            {filtersAndSelectedValues}
                            <div className="graphs">
                                {teamPercentageOfJibedAgentsNode}
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel >
                        <div className="flex-container" style={{
                            minHeight: '38px', margin: '0 0 15px 0', borderBottom: '1px solid #E6F7F8',
                        }}>
                            <div>
                                <div className="title-primary-400-24-28" style={{ fontSize: '14px' }}>
                                    {teamPredictionAccuracyTitle}
                                </div>
                            </div>
                        </div>
                        <div>
                            <div>
                                {teamSelect}
                            </div>
                            {filtersAndSelectedValues}
                            <div className="graphs">
                                {teamPredictionAccuracyNode}
                            </div>
                        </div>
                    </TabPanel>
                </Tabs >
            </div>);
    }
};

const select = state => ({ ...state.CalibrationV3Screen });
export default connect(select)(TeamsCompareAndOverTimeGraphs);
